<template>
    <div class="panel-product">
        <div class="index-container">
            <div class="index-title-group">
                <div class="index-title"><div>产品中心</div></div>
                <div class="index-title-sub">新理念、新架构、新思维，打造数字化智能工厂</div>
            </div>
            <div class="row">
                <div class="col-sm-5 p-item-group">
                    <div class="p-item">
                        <div class="p-icon icon1"></div>
                        <div class="p-item-body">
                            <div class="p-item-title">90%</div>
                            <div class="p-item-title-sub">提高生产效率 设备开动率</div>
                        </div>
                    </div>
                    <div class="p-item">
                        <div class="p-icon icon2"></div>
                        <div class="p-item-body">
                            <div class="p-item-title">34%</div>
                            <div class="p-item-title-sub">提高产品质量，制造成本降低</div>
                        </div>
                    </div>
                    <div class="p-item">
                        <div class="p-icon icon3"></div>
                        <div class="p-item-body">
                            <div class="p-item-title">40%</div>
                            <div class="p-item-title-sub">降低成本 减少用工</div>
                        </div>
                    </div>
                    <div class="p-item">
                        <div class="p-icon icon4"></div>
                        <div class="p-item-body">
                            <div class="p-item-title">23%</div>
                            <div class="p-item-title-sub">缩短制造周期</div>
                        </div>
                    </div>
                    <div class="p-item">
                        <div class="btn-more" @click="goProduct">查看更多&nbsp;→</div>
                    </div>
                </div>
                <div class="col-sm-7 text-center">
                    <img src="../../resource/img/index/p-1.png" width="72%">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "product",
    methods: {
        goProduct() {

        }
    }
}
</script>

<style scoped>
.panel-product {
    background: url("../../resource/img/index/bg-1.jpg") no-repeat;
    background-size: 100% 100%;
    padding: 65px 0;
}

.p-item-group {
    padding-top: 10px;
    padding-left: 40px;
}

.p-item {
    display: flex;
    align-items: center;
    color: #555;
    margin-top: 50px;
}

.p-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-right: 30px;
}

.p-icon.icon1 {
    background: #eeac00 url("../../resource/img/index/i13.png") no-repeat center;
}
.p-icon.icon2 {
    background: #159838 url("../../resource/img/index/i14.png") no-repeat center;
}
.p-icon.icon3 {
    background: #219fc5 url("../../resource/img/index/i15.png") no-repeat center;
}
.p-icon.icon4 {
    background: #1f7a7d url("../../resource/img/index/i16.png") no-repeat center;
}

.p-item-title {
    font-family: "PingFang SC-Bold", "Source Han Sans CN", sans-serif;
    font-size: 48px;
    line-height: 48px;
    font-weight: bolder;
}

.p-item-title-sub {
    font-size: 16px;
}

.btn-more {
    color: #1d4f8e;
    cursor: pointer;
    transition: all 0.3s;
}

.btn-more:hover {
    color: #2575b3;
}
</style>
